import { render } from "./safeHtml.vue?vue&type=template&id=623daee2&scoped=true"
import script from "./safeHtml.vue?vue&type=script&lang=js"
export * from "./safeHtml.vue?vue&type=script&lang=js"

import "./safeHtml.vue?vue&type=style&index=0&id=623daee2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623daee2"]])

export default __exports__